<template>
  <div :class="`kt-login__${type}`">
    <div class="kt-login__head">
      <slot name="head" />
    </div>
    <div class="kt-login__form">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormWrapper',
  props: {
    type: {
      type: String,
      default: 'signin'
    }
  }
}
</script>
